import { useState, useEffect } from "react";
import {ApiUrl} from "../../ApiUrl"
const useFetchBloodGroups = () => {
  const [bloodGroups, setBloodGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchBloodGroups = async () => {
      const apiURL = `${ApiUrl.apiurl}BLOODGROUP/GetAllBloodGroupList/`;
      try {
        const response = await fetch(apiURL);
        const result = await response.json();
        if (response.ok) {
          setBloodGroups(Array.isArray(result?.data) ? result.data : []);
        } else {
          setError(result.message);
        }
      } catch (err) {
        setError("Failed to fetch countries");
        setBloodGroups([]);
      } finally {
        setLoading(false);
      }
    };
    fetchBloodGroups();
  }, []);
  return { bloodGroups, loading, error };
};
export default useFetchBloodGroups;